/**
 * @module app.ext.mcg-informed
 */

import { autoinject } from 'aurelia-framework';
import { AssessmentContext } from 'app/ext/mcg-informed/assessment-context';
import { IQuestionComponent, IQuestionConfig } from 'app/ext/mcg-informed/interfaces';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { QuestionBase } from 'app/ext/mcg-informed/question-base';
import { ApiDateTime } from 'app/shared/models/essette-api';
import * as Mcg from 'app/ext/mcg-informed/interfaces';

@autoinject()
export class QuestionDateCustomElement extends QuestionBase implements IQuestionComponent {

    ////****************** Fields and Properties **************************************////

    protected selectedDate: ApiDateTime | null = null;
    protected selectedDateCopy: ApiDateTime | null = null;

    ////****************** Lifecycle events (in order of execution) ******************////

    constructor(
        protected readonly context: AssessmentContext,
        private readonly logger: AppLogger) {

        super(context);
        this.logger.source = this;

        if(!context || !context.currentSession) throw new Error("No Assessment context is available");

        if(!this.context.questionComponents.includes(this)) this.context.questionComponents.push(this);
    }

    protected async activate(config: IQuestionConfig): Promise<void> {
        this.question = config.question;
        this.readonly = config.readonly;
        this.labelId = config.labelId;
    }

    protected attached(): void {
        this.loadPreviousAnswer();
    }

    ////****************** Events ***********************************************////

    protected handleValueChanged(): void {
        this.context.unsavedChanges = true;
    }

    ////****************** Functions ****************************************************////

    private async loadPreviousAnswer(): Promise<void> {
        if(!this.question || this.question.answersSet.length === 0 || !this.context.attachment.currentAnswers) return;

        try {
            this.selectedDate = this.question.answersSet[0].value;
            this.selectedDateCopy = this.selectedDate;
        }
        catch(error) {
            const questionId = this.question && this.question.id;
            const description = this.question && this.question.questionText || '';

            this.logger.error(`Unable to find existing answer for question ${questionId} (${description})`);
            throw error;
        }
    }

    ////****************** IQuestionComponent ****************************************************////

    public saveAnswer = null;  // Not Implemented

    public getAnswers(): Mcg.Choice[] {
        if(!this.question || this.question.answersSet.length === 0 || !this.selectedDate || this.selectedDate.length === 0) return [];

        const answer: Mcg.Choice = {
            text: '',
            value: this.selectedDate,
            id: this.question.answersSet[0].id,
            uid: this.question.answersSet[0].uid,
            sequence: null,
            guidelineLinkSet: [],
            annotationSet: [],
            citationSet: [],
            footnoteSet: [],
            questionRefSet: [],
            subinterventionsSet: []
        };

        return [answer];
    }

    public getGuidelineLinks = null; // Not Implemented

    public clearSelectedAnswers(): void {
        this.selectedDate = null;
    }

}
